import React from 'react';
import PropTypes from 'prop-types';
import { Field, FieldLabel, FieldValue } from './SummaryShared';

// Renders an optional labelled note row (e.g. message to translator,
// customer service instructions). Renders nothing when the value is empty.
const SummaryNote = ({ label, value }) => {
  if (!value) return null;
  return (
    <Field>
      <FieldLabel>{label}</FieldLabel>
      <FieldValue>{value}</FieldValue>
    </Field>
  );
};

SummaryNote.propTypes = {
  label: PropTypes.string.isRequired,
  value: PropTypes.string,
};

export default SummaryNote;
